<template>
    <!-- Header 표시 여부 제어 -->
    <Header v-if="showHeader" />
    <!-- <Side v-if="isMain" /> -->
    <Content />
    <!-- Footer 표시 여부 제어 -->
    <Footer v-if="showFooter" />
</template>

<script>
import Header from '@/components/inc/header'
import Footer from '@/components/inc/footer'
import Content from '@/components/inc/content'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
    components: {
        Header,
        Footer,
        Content
    },
    setup() {
        const route = useRoute()

        // Header 표시 여부 결정
        const showHeader = computed(() => {
            const hiddenHeaderRoutes = ['login','evalJoin', 'join', 'orgJoin',"joinType","findID","findPW",'Home']; 
            return !hiddenHeaderRoutes.includes(route.name); 
        });

        // Footer 표시 여부 결정
        const showFooter = computed(() => {
            const hiddenFooterRoutes = ['login','createEval','join', 'orgJoin','myPage',"joinType","findID","findPW",'Home',"organizationGiasStats"]; 
            return !hiddenFooterRoutes.includes(route.name); 
        });

        const isMain = computed(() => {
            // 필요 시 스토어의 값을 활용해 Side 컴포넌트 표시 여부 결정
            return store.state.temp.isMain;
        });

        return {
            isMain,
            showHeader,
            showFooter
        }
    }
}
</script>
